import {
  Component,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { RISK_FILTERS } from 'src/app/models/filter-details.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'

const NEGATIVE_ONE = -1

@Component({
  selector: 'risk-filter',
  templateUrl: './riskFilter.component.html',
  styleUrls: ['./riskFilter.component.scss'],
})
export class RiskFilterComponent implements OnDestroy {
  // AEM content Vars
  careAboutRisk: AEMChunk
  aemContentSub: Subscription
  risk: string
  description: string
  riskDesc: string[] = [
    'Conservative funds (Less risk)',
    'Conservative to moderate funds',
    'Moderate funds',
    'Moderate to aggressive funds',
    'Aggressive funds (More risk)',
  ]

  // eslint-disable-next-line max-params
  constructor(
    private readonly filtersService: FiltersService,
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  public readonly riskFilters: string[] = RISK_FILTERS

  onRiskSelected(event) {
    if (
      this.filtersService.activeFilters.risk.indexOf(event.target.value) >
      NEGATIVE_ONE
    ) {
      this.filtersService.activeFilters.risk.splice(
        this.filtersService.activeFilters.risk.indexOf(event.target.value),
        1,
      )
    } else {
      this.filtersService.activeFilters.risk.push(event.target.value)
    }
    this.filtersService.applyFilters()
  }

  isRiskSelected(value) {
    return (
      this.filtersService.activeFilters.risk.indexOf(value) !== NEGATIVE_ONE
    )
  }

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
      this.careAboutRisk = this.centralContentService.getContentByBody(
        'fund_definitions_why_should_i_care_about_risk',
        content,
      )
  }

  formatLink(str) {
    const from = ['&lt;', '&gt;', '&amp;', '&quot;', '>nbsp;']
    const to = ['<', '>', '&', '"', ' ']
    from.forEach((data, index) => {
      str = this.regularExpression(str, data, to[index])
    })
    return str
  }
  regularExpression(str, find, replace) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
    return str.toString().replace(new RegExp(escapedFind, 'g'), replace)
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
